import logoDark from '@/assets/img/logo.png';
import logoLight from '@/assets/img/logo-light.png';
import { useTheme } from '@/contexts/ThemeContext';

/**
 * Theme-aware RoniDoc logo. Picks light/dark variant based on the current
 * ThemeContext. Drop-in replacement for `<img src={logoImg} ... />`.
 *
 * On pages that render outside the ThemeProvider (or want to force a
 * variant), pass `variant="light" | "dark"` to override.
 */
export function Logo({
  className = 'h-8 w-auto',
  alt = 'RoniDoc AI',
  variant,
}: {
  className?: string;
  alt?: string;
  variant?: 'light' | 'dark';
}) {
  let resolved: 'light' | 'dark' = variant || 'dark';
  if (!variant) {
    try {
      const { theme } = useTheme();
      resolved = theme === 'light' ? 'light' : 'dark';
    } catch {
      // outside ThemeProvider - fall back to dark
    }
  }
  return <img src={resolved === 'light' ? logoLight : logoDark} alt={alt} className={className} />;
}
